import { Link } from "react-router-dom";
import "./Footer.css";
import footerBg from "../../images/web_obrazek_pozadi.webp";
import logoWhite from "../../images/logo-white.webp";
import InstagramLogo from "../../images/instagramLogo.svg";
import TwitterLogo from "../../images/TwitterLogo.svg";
import DyskordLogo from "../../images/DyskordLogo.svg";

export default function Footer() {
    return (
        <div id="footer" style={{ backgroundImage: `url(${footerBg})` }}>
            <div id="footerContent">
                <div className="footerCol">
                    <h3 className="footerNadpis">Odkazy</h3>
                    <ul className="footerList">
                        <li>
                            <a href="https://eu.zonerama.com/CSA-galerie/1988539" target="_blank" rel="noreferrer noopener">
                                složka s fotkami
                            </a>
                        </li>
                        <li>
                            <a href="https://www.asocialove.cz/pfp" target="_blank" rel="noreferrer noopener">
                                ČSA rámečky
                            </a>
                        </li>
                         <li>
                            <a href="https://pravo.asocialove.cz" target="_blank" rel="noreferrer noopener">
                                Asociální Právo
                            </a>
                        </li>
                        <li>
                            <Link to="/source">zdrojový kód</Link>
                        </li>
                    </ul>
                </div>

                <div className="footerCol">
                    <h3 className="footerNadpis">Rychlá navigace</h3>
                    <ul className="footerList">
                        <li>
                            <Link to="/pomoc">členství</Link>
                        </li>
                        <li>
                            <Link to="/pomoc?tab=mladetrosky">mladé trosky</Link>
                        </li>
                        <li>
                            <Link to="/pomoc?tab=donation">ožebračení</Link>
                        </li>
                        <li>
                            <Link to="/volby#program">program</Link>
                        </li>
                        <li>
                            <Link to="/financování">financování</Link>
                        </li>
                    </ul>
                </div>

                <div className="footerCol footerKontakty">
                    <h3 className="footerNadpis">Kontakty</h3>
                    <ul className="footerList footerKontaktyList">
                        <li>
                            <a href="mailto:strana@asocialove.cz">
                                <span className="material-symbols-outlined">mail</span>
                                strana@asocialove.cz
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/ceska_strana_antisocialni/" target="_blank" rel="noreferrer noopener">
                                <img src={InstagramLogo} alt="" />
                                Instagram
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/CAsocialu" target="_blank" rel="noreferrer noopener">
                                <img src={TwitterLogo} alt="" />
                                Twitter
                            </a>
                        </li>
                        <li>
                             <a href="https://discord.gg/E5RK8VKpyT" target="_blank" rel="noreferrer noopener">
                                <img src={DyskordLogo} alt="" />
                                Discord
                            </a>
                        </li>
                        <li>
                            <Link  to="/kontakty">a další...</Link>
                        </li>
                    </ul>
                </div>

                <div className="footerBottom">
                    <span>zadavatel: ČSA, zpracovatel: Richard Kužela, Jan Peška, Tomáš Setunský</span>
                    <img className="footerLogo" src={logoWhite} alt="Logo České Strany Asociálů" draggable="false" />
                </div>
            </div>
        </div>
    );
}
